export default
/* glsl */
"\n#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif\n";